import { intl } from "LocaleWrapper";
import { Select, SelectProps } from "@cofano/cck";
import { StatusEstimateRequirement } from "__generated__/enums";

const StatusEstimateRequirementSelect = ({ value, onChange }: Omit<SelectProps<StatusEstimateRequirement, false>, "fetchOptions">) => {

	const options = [ {
		id: StatusEstimateRequirement.Optional,
		name: intl.formatMessage({ id: "OPTIONAL" }),
	}, {
		id: StatusEstimateRequirement.Required,
		name: intl.formatMessage({ id: "REQUIRED" }),
	} ];

	return (
		<Select
			disableSearch
			clearable={false}
			fetchOptions={options}
			value={options.find(option => option.id === value)}
			onChange={(option) => onChange?.(option?.id ?? null, false)} />
	);
};

export default StatusEstimateRequirementSelect;
